import { createUseStyles } from 'react-jss';

export const useHomeHeroStyles = createUseStyles({
  bgBlueWhiteHorizontal: {
    background: 'linear-gradient( white 20%, #0032a0  20%)',
    '@media (min-width: 1024px)': {
      background: 'linear-gradient( white 80%, #0032a0  80%)',
    },
  },
  bgHero: {
    marginTop: '6%',
    '@media (min-width: 1024px)': {
      marginTop: '1%',
    },
  },
});
